/* RESPONSIBLE TEAM: team-channels */
import ProductSettingsRoute from 'embercom/routes/apps/app/settings/base/product-settings-route';
import { inject as service } from '@ember/service';

export default class EmailConversationHistorySettings extends ProductSettingsRoute {
  @service intl;
  @service store;

  analytics = {
    section: 'settings',
    place: 'email_conversation_history_settings',
  };
  get titleToken() {
    return this.intl.t('channels.email.settings.conversation_history.title');
  }

  get app() {
    return this.modelFor('apps.app');
  }

  model() {
    return this.store.findRecord('email-conversation-history-settings', this.app.id);
  }

  activate() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'visited',
      section: 'settings',
      place: 'email_conversation_history_settings',
      object: 'email_conversation_history_settings',
    });
  }
}
